/* eslint-disable global-require */

export default {
  homescapes: [
    {
      type: 'image',
      link: require('@/assets/images/homescapes/preview/it/preview-01.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/homescapes/preview/it/preview-02.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/homescapes/preview/it/preview-03.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/homescapes/preview/it/preview-04.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/homescapes/preview/it/preview-05.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/homescapes/preview/it/preview-06.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/homescapes/preview/it/preview-07.webp'),
    },
  ],
  township: [
    {
      type: 'image',
      link: require('@/assets/images/township/preview/it/preview-01.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/township/preview/it/preview-02.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/township/preview/it/preview-03.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/township/preview/it/preview-04.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/township/preview/it/preview-05.webp'),
    },
  ],
};
